import React, { useState } from 'react';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import PlayButton from 'assets/images/Play-Button-S.png';
import { Image } from 'components/atoms/image';
import { HTMLView } from 'components/atoms/htmlView';
import TUIG from '../../../assets/images/TUIG.png';

const TestimonialMobileCard = props => {
  const {
    data,
    isMemberRoleVisible,
    mediaPath,
    imagePath,
    sectionType,
  } = props;

  const [showVideoLayout, setShowVideoLayout] = useState(false);
  const mediaUrl = `${mediaPath}${data.mobile}`;
  const videoMediaUrl = data.video_thumbnail ? data.video_thumbnail : TUIG;
  const showOverlay = showVideoLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={data.url_video}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'testimonialVideoOverlay'}
        onClosePress={() => setShowVideoLayout(false)}
        breadcrumbList={[{ breadcrumbName: 'Homes' }, 'Testimonial']}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'mobile_card'}>
      <Image
        className={'mobile_testimonial'}
        src={
          sectionType === 'videos' ? videoMediaUrl : `${mediaUrl}/${imagePath}`
        }
        alt={'videos'}
      />
      <div
        className={sectionType === 'videos' ? 'box_align videos' : 'box_align'}
      >
        <h1 className={'testimonial-name'}>{data.name}</h1>
        <HTMLView
          html={data.description}
          tagName={'h4'}
          className={'testimonial-description'}
        />
      </div>
      <div className={'line-align'} />
      {isMemberRoleVisible && (
        <h4 className={'member-role'}>{data.project_name}</h4>
      )}
      {data.url_video && (
        <button className={'play-button'}>
          <img
            src={PlayButton}
            alt={'PlayButton'}
            onClick={() => setShowVideoLayout(true)}
            className={
              sectionType === 'videos'
                ? 'play-button-img videos'
                : 'play-button-img'
            }
          />
        </button>
      )}
      {showOverlay}
    </div>
  );
};
export default TestimonialMobileCard;
